import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface GearIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const GearIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: GearIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M12 14.75C13.6569 14.75 15 13.4069 15 11.75C15 10.0931 13.6569 8.75 12 8.75C10.3431 8.75 9 10.0931 9 11.75C9 13.4069 10.3431 14.75 12 14.75Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.069 3.11281C10.7151 1.29573 13.2849 1.29573 13.931 3.1128C14.338 4.2571 15.6451 4.79852 16.742 4.27713C18.4837 3.44918 20.3008 5.26625 19.4729 7.00803C18.9515 8.10491 19.4929 9.41203 20.6372 9.819C22.4543 10.4651 22.4543 13.0349 20.6372 13.681C19.4929 14.088 18.9515 15.3951 19.4729 16.492C20.3008 18.2337 18.4837 20.0508 16.742 19.2229C15.6451 18.7015 14.338 19.2429 13.931 20.3872C13.2849 22.2043 10.7151 22.2043 10.069 20.3872C9.66203 19.2429 8.35491 18.7015 7.25803 19.2229C5.51625 20.0508 3.69918 18.2337 4.52713 16.492C5.04852 15.3951 4.5071 14.088 3.3628 13.681C1.54573 13.0349 1.54573 10.4651 3.36281 9.819C4.5071 9.41203 5.04852 8.10491 4.52713 7.00803C3.69918 5.26625 5.51625 3.44918 7.25803 4.27713C8.35491 4.79852 9.66203 4.2571 10.069 3.11281Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default GearIcon
